export default __webpack_public_path__ + "static/media/sea_of_clouds.8bcac22f.jpg";